<template>
  <VLayout pa-4>
    <VFlex xs12>
      <VCard style="height: 80vh; overflow-y: auto">
        <VLayout justify-space-around align-center row fill-height>
          <VFlex xs4>
            <VCardTitle style="padding-left: 0; font-variant: small-caps">
              <h1>Nastavitve</h1>
            </VCardTitle>
            <VForm ref="form" @submit.prevent="confirmData">
              <VTextField
                v-model="enterpriseConfiguration.name"
                v-validate="'required'"
                :error-messages="errors.collect('company_name')"
                data-vv-name="company_name"
                name="company_name"
                data-vv-as="Ime podjetja"
                label="Ime podjetja"
              />
              <VTextField
                v-model="enterpriseConfiguration.to_mail"
                v-validate="'required|email'"
                :error-messages="errors.collect('to_mail')"
                data-vv-name="to_mail"
                data-vv-as="Prejemnik"
                label="Prejemnik"
              />
              <VCombobox
                v-model="selectedEmails"
                v-validate="'required|email_array'"
                :error-messages="errors.collect('admin_emails')"
                data-vv-name="admin_emails"
                data-vv-as="Elektronski naslov administratorja"
                label="Elektronski naslov administratorja"
                multiple
                chips
                deletable-chips
              />

              <VCombobox
                v-model="enterpriseConfiguration.whitelist_emails"
                v-validate="'email_array'"
                :error-messages="errors.collect('whitelist_emails')"
                data-vv-name="whitelist_emails"
                data-vv-as="Email whitelist"
                label="Whitelist elektronskih naslovov"
                multiple
                chips
                deletable-chips
              />

              <VLayout row wrap justify-space-around mt-3>
                <VCheckbox
                  v-model="enterpriseConfiguration.ignore_low_dpi"
                  label="Ignore low DPI"
                  name="dpiCheckbox"
                  color="primary"
                />
                <VTooltip top style="float: right">
                  <VBtn
                    slot="activator"
                    icon
                    fab
                    large
                    flat
                    color="primary"
                    class="d-inline-block"
                    name="confirmData"
                    :disabled="errors.any()"
                    @click="confirmData"
                  >
                    <VIcon>done</VIcon>
                  </VBtn>
                  <span>Potrditev podatkov</span>
                </VTooltip>
              </VLayout>
            </VForm>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { getEnterpriseConfig, updateEnterpriseConfig, axiosInstance } from '../services/api';

export default {
  name: 'Settings',
  data() {
    return {
      selectedEmails: [],
      selectedWhitelistEmails: [],
      whitelistEmails: [],
      enterpriseConfiguration: {
        name: '',
        to_mail: '',
        admin_emails: '',
        whitelist_emails: [],
        ignore_low_dpi: false,
      },
    };
  },
  mounted() {
    this.fetchEnterpriseConfig();
  },
  methods: {
    ...mapActions(['setSnackBarStateAction']),
    async fetchEnterpriseConfig() {
      try {
        const { data } = await getEnterpriseConfig();
        if (data.length) {
          [this.enterpriseConfiguration] = data;
        }
        if (this.enterpriseConfiguration.admin_emails) {
          this.selectedEmails = this.enterpriseConfiguration.admin_emails
            .split(',')
            .filter((email) => email.trim());
        }
      } catch (error) {
        this.setSnackBarStateAction({
          snackBar: true,
          color: 'error',
          text: 'Napaka pri nalaganju nastavitev',
        });
      }
    },
    async confirmData() {
      const isValid = await this.$validator.validateAll();

      try {
        const updateObject = { ...this.enterpriseConfiguration };
        updateObject.admin_emails = this.selectedEmails.join(',');

        if (updateObject.url) {
          await axiosInstance.put(updateObject.url, updateObject);
        } else {
          await updateEnterpriseConfig(updateObject);
        }

        this.setSnackBarStateAction({
          snackBar: true,
          color: 'success',
          text: 'Uspešno ste potrdili nastavitve!',
        });
      } catch (e) {
        this.setSnackBarStateAction({
          snackBar: true,
          color: 'error',
          text: 'Zgodila se je napaka! Kontaktirajte administratorja.',
        });
      }
    },
  },
};
</script>
